import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { ApiService }               from '../api/api.service';
import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { WsApiSettingsComponent }   from './ws-api.settings.component';
import { WsApiSettingsModel }       from './models/ws-api.settings.model';

export const WsApiStates : Array<NgHybridStateDeclaration> = [
  {
    component: WsApiSettingsComponent,
    name     : 'app.ws-api-settings',
    resolve  : [
      {
        deps     : [ ApiService ],
        resolveFn: ( apiService : ApiService ) : ng.IPromise<CompanyIntegrationsModel> => apiService.get('/company_integrations'),
        token    : 'settings'
      },
      {
        deps     : [ ApiService ],
        resolveFn: ( apiService : ApiService ) : ng.IPromise<WsApiSettingsModel> => apiService.get('/company_integrations/get_workshop_api_details'),
        token    : 'wsApiSettings'
      }
    ],
    url: '/ws-api-settings'
  }
];
